module.exports = __webpack_public_path__ + "static/img/icon3.d7117b77.png";